import { axiosClient } from './AxiosClient'

function listFeedback(callback, errorCallback){
    let url = "/feedback/list"
    axiosClient.get(url)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createFeedback(feedbackTitle, feedbackDetail, attachImage, callback, errorCallback){
    let url = "/feedback/create"   
    var bodyForm = new FormData()
    bodyForm.append("title", feedbackTitle)
    bodyForm.append("detail", feedbackDetail)
    bodyForm.append("service", "Lifelink Webadmin")
    if(attachImage !== null){
        bodyForm.append("attach_file", attachImage)
    }
    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewFeedback(feedbackId, callback, errorCallback){
    let url = "/feedback/view/" + feedbackId
    axiosClient.get(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function markResolve(feedbackId, solve, response, callback, errorCallback){
    let url = "/feedback/markSolve"
    var bodyForm = new FormData()
    bodyForm.append("feedback_id", feedbackId)
    bodyForm.append("solve", solve)
    if(response !== null && response !== ""){
        bodyForm.append("response", response)
    }
    
    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { listFeedback, createFeedback, viewFeedback, markResolve }